// warning
export const getWarning = warning =>
  warning && warning.showWarning ? warning.showWarning : false;
export const getWarningStatus = warning =>
  warning && warning.status ? warning.status : false;



// WEBPACK FOOTER //
// ./src/selectors/warning.js